import script from "./RcModalDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcModalDialog.vue?vue&type=script&setup=true&lang=ts"

import "./RcModalDialog.vue?vue&type=style&index=0&id=ffefbbea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffefbbea"]])

export default __exports__